import { Navigate, RouteObject } from 'react-router-dom';
import { SharesOld } from 'app/components/Shares';
import React from 'react';
import { routes } from 'app/routing/routesConfig';
import { AuddlySignUp } from 'app/views/AuddlySignUp';
import { WebPageNotFound } from 'app/components/WebPageNotFound';

export const webRoutes: RouteObject[] = [
  { path: routes.shares.route, element: <SharesOld /> },
  { path: routes.auddlySignUp.route, element: <AuddlySignUp /> },
  {
    path: routes.webPageNotFound.route,
    element: <WebPageNotFound />,
  },
  { path: '*', element: <Navigate to={routes.webPageNotFound.path} /> },
];
